import { apiHost } from '../../../config';
import { deleteRequest } from '../../requests';

export default async function deleteTeacher(id: number) {
  return deleteRequest(`${apiHost}/api/admin/users/${id}`);
}
